module.exports = __webpack_public_path__ + "img/CRM_swiperTab_img3.aad6c80e.png";